import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { CheckCircle2, Loader2 } from "lucide-react";

export default function Appraisal() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", city: "", property_type: "apartament", message: "" });
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/appraisal/request", form);
      setDone(true);
    } catch (err) { toast.error(err?.response?.data?.detail || "Eroare"); }
    finally { setLoading(false); }
  };

  const input = "w-full border-b border-[#0D1F2D] bg-transparent py-3 text-lg font-display focus:outline-none focus:border-[#0F6E5B] placeholder:text-[#A0A5AC]";

  return (
    <main data-testid="appraisal-page" className="bg-[#F6F4EE] min-h-screen text-[#0D1F2D]">
      <div className="max-w-[1100px] mx-auto px-6 lg:px-10 py-14 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="mono text-[11px] uppercase tracking-[0.22em] text-[#52616B]">§ Evaluare oficială ANEVAR</div>
          <h1 className="font-display text-5xl font-bold tracking-tight mt-3">Un expert la fața locului.</h1>
          <p className="mt-5 text-[#52616B] leading-relaxed">
            Pentru rapoarte acceptate de bănci, instanțe sau notari, îți conectăm cu un evaluator ANEVAR autorizat din zona ta.
            Răspundem în 24h cu ofertă detaliată.
          </p>
          <div className="mt-8 space-y-3">
            {["Raport conform standardelor ANEVAR", "Acceptat de bănci și notari", "Deplasare + inspecție inclusă", "Livrare în 3-5 zile lucrătoare"].map(x => (
              <div key={x} className="flex items-start gap-3"><CheckCircle2 size={18} className="text-[#0F6E5B] mt-0.5" /><span className="text-sm">{x}</span></div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-7">
          {done ? (
            <div className="bg-white border border-[#DEDCCF] p-12 text-center">
              <CheckCircle2 size={48} className="text-[#0F6E5B] mx-auto" />
              <div className="font-display text-3xl font-bold mt-5">Cerere trimisă.</div>
              <p className="mt-3 text-[#52616B]">Un evaluator te va contacta în maximum 24 de ore.</p>
            </div>
          ) : (
            <form onSubmit={submit} className="bg-white border border-[#DEDCCF] p-8 lg:p-10 space-y-6" data-testid="appraisal-form">
              <div>
                <label className="mono text-[11px] uppercase tracking-[0.22em] text-[#52616B]">Nume complet *</label>
                <input data-testid="apr-name" required value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} className={input} />
              </div>
              <div className="grid sm:grid-cols-2 gap-6">
                <div>
                  <label className="mono text-[11px] uppercase tracking-[0.22em] text-[#52616B]">Email *</label>
                  <input data-testid="apr-email" type="email" required value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} className={input} />
                </div>
                <div>
                  <label className="mono text-[11px] uppercase tracking-[0.22em] text-[#52616B]">Telefon *</label>
                  <input data-testid="apr-phone" required value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} className={input} />
                </div>
              </div>
              <div className="grid sm:grid-cols-2 gap-6">
                <div>
                  <label className="mono text-[11px] uppercase tracking-[0.22em] text-[#52616B]">Oraș *</label>
                  <input data-testid="apr-city" required value={form.city} onChange={e => setForm({ ...form, city: e.target.value })} className={input} />
                </div>
                <div>
                  <label className="mono text-[11px] uppercase tracking-[0.22em] text-[#52616B]">Tip proprietate *</label>
                  <select data-testid="apr-type" value={form.property_type} onChange={e => setForm({ ...form, property_type: e.target.value })} className={input}>
                    <option value="apartament">Apartament</option>
                    <option value="casa">Casă</option>
                    <option value="teren">Teren</option>
                    <option value="comercial">Comercial</option>
                  </select>
                </div>
              </div>
              <div>
                <label className="mono text-[11px] uppercase tracking-[0.22em] text-[#52616B]">Mesaj (opțional)</label>
                <textarea data-testid="apr-msg" rows={3} value={form.message} onChange={e => setForm({ ...form, message: e.target.value })} className={input + " resize-none"} />
              </div>
              <button data-testid="apr-submit" type="submit" disabled={loading} className="w-full sm:w-auto bg-[#0F6E5B] hover:bg-[#0A5447] text-white px-8 h-14 rounded-sm font-medium flex items-center gap-2 disabled:opacity-50">
                {loading ? <Loader2 className="animate-spin" size={16} /> : null}
                Trimite cererea
              </button>
            </form>
          )}
        </div>
      </div>
    </main>
  );
}
